import { StatusName } from '@range.io/basic-types'
import { taggedSum } from '@range.io/functional'
import { ReduxActions } from '../../redux'
import CommandPlayer from './command-player'

const StatusNameAddedCommand = taggedSum('StatusNameAddedCommand', {
    Inbound: {
        statusName: 'StatusName',
    },
})

const runInboundCommand = (resources, command) => {
    const { dispatch } = resources
    const { statusName } = command
    dispatch(ReduxActions.statusNameAdded(statusName))
    dispatch(ReduxActions.addStatusNameToFilterSettings({ statusName }))
}

const addCommand = (addCommandToHistory, registerCommandPlayer) => {
    registerCommandPlayer(
        StatusNameAddedCommand,
        CommandPlayer({
            CommandType: StatusNameAddedCommand,
            Type: StatusName,
            collectionPath: projectId => `/projects/${projectId}/statusNames/`,
            runInboundCommand,
            runOutboundCommand: () => {},
            addCommandToHistory,
            changeType: 'added',
        })
    )
}

export { addCommand, StatusNameAddedCommand }
